import { PaisDTO, InvestigacionDTO, ClienteDTO } from "@DTOS";

export class DatosModalInvestigacionBasicos {
    public nombreInvestigacion: string;
    public cliente: ClienteDTO;
    public paises: PaisDTO[];
    public fechaHasta: Date;
    public maxRespuestas: number;

    public cargarEnInvestigacion(investigacion: InvestigacionDTO) {
        investigacion.nombre = this.nombreInvestigacion;
        investigacion.cliente = this.cliente;
        investigacion.fechaHasta = this.fechaHasta;
        investigacion.n = this.maxRespuestas;
    }
}
